module.exports = __webpack_public_path__ + "img/sarah_broecker_9.4810264e.jpg";